// AUTO-GENERATED. DO NOT EDIT.
// Source: scripts/i18n/generate_i18n_catalogs.mjs

export const commonErrorApiCodeExam = {
  examAuthInvalidRefreshToken: "登录会话已失效，请重新登录",
  examAuthAccountLocked: "账号已锁定，请稍后重试",
  examAuthCredentialsInvalid: "用户名或密码错误",
  examAuthCaptchaRequired: "请先完成验证码校验",
  examAuthCaptchaInvalid: "验证码不正确，请重试",
  examAuthIpNotAllowed: "当前 IP {ip} 不在允许登录范围内",
  examAuthPasswordReuseDisallowed: "新密码不能与当前密码相同",
  examAuthCurrentPasswordIncorrect: "当前密码不正确",
  examAuthPermissionDenied: "当前账号没有执行该操作的权限",
  examScoringAttemptNotFound: "答卷 #{attempt_id} 不存在",
  examExamNotFound: "考试 #{exam_id} 不存在",
  examExamCodeNotFound: "考试编码 {exam_code} 不存在",
  examExamCodeRequired: "请提供考试编码",
  examEntryRequired: "请提供考试入口编码或入口子域名",
  examEntryNotFound: "未找到匹配的考试入口",
  examEntryCodeConflict: "考试入口编码已被占用",
  examEntrySubdomainConflict: "考试入口子域名已被占用",
  examExamFieldInvalid: "考试字段 {field} 不符合要求",
  examExamStatusUpdateForbidden:
    "考试状态只能通过状态操作从 {current_status} 变更为 {requested_status}",
  examExamArchivedEditForbidden: "考试 #{exam_id} 已归档，无法编辑",
  examExamPaperVersionChangeForbidden: "考试 #{exam_id} 已有答卷，无法变更试卷版本",
  examExamCandidateAssignmentForbidden: "当前考试不允许分配候选人",
  examExamUnsupportedStatusAction: "不支持该考试状态操作",
  examExamStatusTransitionInvalid: "考试 #{exam_id} 当前状态 {current_status} 不允许执行 {action}",
  examExamAssignedCandidatesRequired: "考试 #{exam_id} 执行 {action} 前需要先分配候选人",
  examExamDurationRequired: "考试 #{exam_id} 需要设置大于 0 的考试时长",
  examExamRunningAttemptsExist: "考试 #{exam_id} 仍有进行中的答卷，暂不能归档",
  examExamRequiresEndedStatus: "考试 #{exam_id} 结束后才能发布成绩",
  examExamDeleteRequiresDraft: "考试 #{exam_id} 仅可在草稿状态删除",
  examExamHasAttemptRecords: "考试 #{exam_id} 已有答卷记录，无法删除",
  examCandidateUserNotFound: "候选人用户 #{candidate_id} 不存在",
  examCandidateUserInvalid: "候选人用户 #{candidate_id} 不符合要求：{reason}",
  examCandidateNotAssigned: "候选人 #{candidate_id} 未分配到考试 #{exam_id}",
  examCandidateHasAttempt: "候选人 #{candidate_id} 已有考试 #{exam_id} 的答卷记录",
  examStaffUserNotFound: "监考或评审用户 #{staff_user_id} 不存在",
  examStaffUserInvalid: "监考或评审用户 #{staff_user_id} 不符合要求：{reason}",
  examStaffAssignmentNotFound: "考试 #{exam_id} 中不存在用户 #{staff_user_id} 的人员分配",
  examRuntimeDataContractInvalid: "考试运行时数据合同无效",
  examRuntimeExportDependencyMissing: "考试运行时导出依赖未安装",
  examExamForbidden: "当前账号没有访问考试 #{exam_id} 的权限",
  examAttemptNotFound: "答卷 #{attempt_id} 不存在",
  examAttemptForbidden: "当前账号没有访问答卷 #{attempt_id} 的权限",
  examAttemptQuestionNotFound: "答卷题目 #{attempt_question_id} 不存在",
  examUserValidationFailed: "用户数据不符合要求",
  examUserDataContractInvalid: "用户数据合同无效",
  examCandidateImportValidationFailed: "候选人导入数据不符合要求",
  examCandidateImportDependencyUnavailable: "候选人导入或模板导出依赖暂不可用",
  examCandidateImportTemplateGenerationFailed: "候选人导入模板生成失败",
  examQuestionNotFound: "题目 #{question_id} 不存在",
  examQuestionCodeNotFound: "题目编码 {question_code} 不存在",
  examQuestionVersionNotFound: "题目 #{question_id} 的版本不存在",
  examQuestionValidationFailed: "题目数据不符合要求",
  examQuestionStateConflict: "题目 #{question_id} 当前状态 {current_status} 不允许执行 {action}",
  examQuestionInUse: "题目 #{question_id} 正被 {reference_type} 引用，无法删除",
  examCustomFieldValidationFailed: "自定义字段数据不符合要求",
  examCustomFieldNotFound: "自定义字段定义或关联资源不存在",
  examEnvironmentPracticalSessionQuestionTypeNotSupported:
    "题目 #{question_id} 的类型 {question_type} 不支持体验会话",
  examEnvironmentPracticalSessionContainerIdRequired: "请提供容器 ID",
  examEnvironmentFlagValidationQuestionTypeNotSupported:
    "题目 #{question_id} 的类型 {question_type} 不支持 Flag 校验",
  examEnvironmentFlagValidationActiveInstanceRequired:
    "题目 #{attempt_question_id} 没有可用的环境实例",
  examEnvironmentFlagValidationInstanceDestroyed: "环境实例 #{instance_id} 已销毁，无法校验 Flag",
  examEnvironmentCallbackInstanceDestroyed: "环境实例 #{instance_id} 已销毁，无法接收回调",
  examEnvironmentCallbackTokenMismatch: "环境回调 token 无效",
  examEnvironmentCallbackTokenRequired: "请提供环境回调 token",
  examEnvironmentInstanceQuestionTypeNotSupported:
    "题目 #{question_id} 的类型 {question_type} 不支持环境执行",
  examEnvironmentInstanceCreationLimitExceeded:
    "题目 #{attempt_question_id} 的环境创建次数已达上限 {max_create_count}",
  examEnvironmentInstanceImageRequired: "题型 {question_type} 的环境实例需要配置镜像",
  examEnvironmentInstanceContainerPortInvalid: "题型 {question_type} 的环境实例端口配置无效",
  examEnvironmentInstanceInitScriptUnsupported:
    "题型 {question_type} 的容器黑盒环境不支持初始化脚本",
  examEnvironmentInstanceDataContractInvalid: "环境实例持久化数据合同无效（字段：{field}）",
  examEnvironmentNodeRuntimeRequestFailed: "节点运行时请求失败",
  examEnvironmentNodeRuntimeUnavailable: "节点运行时暂不可用",
  examEnvironmentNodeRuntimeDataContractInvalid:
    "节点运行时返回的数据合同无效（操作：{operation}，字段：{field}）",
  examEnvironmentExecutionFabricConfigurationMissing: "执行织网配置缺失（字段：{field}）",
  examEnvironmentCandidateConcurrentLimitExceeded:
    "当前同时运行的环境数量 {active_count} 已达上限 {max_active_count}",
  examEnvironmentCandidateTotalCreationLimitExceeded:
    "环境创建总数 {total_count} 已达上限 {max_total_count}",
  examEnvironmentEvaluationInstanceDestroyed: "环境实例 #{instance_id} 已销毁，无法执行自检",
  examEnvironmentEvaluationSelfCheckDisabled:
    "当前考试不允许对答卷题目 #{attempt_question_id} 执行自检",
  examEnvironmentEvaluationSelfCheckLimitExceeded:
    "答卷题目 #{attempt_question_id} 的自检次数已达到上限 {max_self_check_count}（已使用 {used_self_check_count} 次）",
  examEnvironmentEvaluationDataContractInvalid:
    "环境实例 #{instance_id} 的评测数据合同无效（字段：{field}）",
  examEnvironmentEvaluationLocalWorkspaceUnavailable:
    "环境实例 #{instance_id} 的本地工作目录不可用，请重建环境后再试",
  examEnvironmentDockerInstanceImageRequired: "请提供实例镜像名称",
  examEnvironmentDockerInstanceContainerIdRequired: "请提供 Docker 实例 ID",
  examEnvironmentDockerInstanceDataContractInvalid: "Docker 实例服务返回的数据结构无效",
  examEnvironmentTaskCenterExecutionCenterRequired: "此任务中心操作需要执行中心模式",
  examEnvironmentTaskCenterHandoffFailed: "任务中心请求失败，请稍后重试",
  examEnvironmentTaskCenterDataContractInvalid: "任务中心返回的数据结构无效",
  examEnvironmentOrchestratorHandoffFailed: "环境实例销毁请求提交到编排中心失败",
  examEnvironmentDockerImageImageRequired: "请提供镜像名称",
  examEnvironmentDockerImageNotFound: "镜像不存在：{image}",
  examEnvironmentDockerImageDataContractInvalid: "镜像服务返回的数据结构无效",
  examEnvironmentDockerImageExecutionCenterRequired: "此镜像操作需要执行中心模式",
  examEnvironmentDockerImageDefaultPortInvalid: "默认端口无效",
  examEnvironmentDockerImageDefaultPortNotDeclared: "默认端口不在镜像声明的端口范围内",
  examEnvironmentDockerImageArchiveNotFound: "镜像归档文件不存在",
  examEnvironmentDockerImageArchiveInvalid: "镜像归档必须是有效的 tar 文件",
  examEnvironmentDockerImageArchiveTooLarge: "镜像归档超过大小限制（{max_bytes} 字节）",
  examEnvironmentDockerImageAssetImportFailed: "从资源中心导入镜像失败",
  examEnvironmentDockerImageDockerfileRequired: "请提供 Dockerfile 内容",
  examEnvironmentDockerImageDockerfileTooLarge: "Dockerfile 内容超过大小限制（{max_bytes} 字节）",
  examEnvironmentDockerImageBuildTimeout: "镜像构建超时",
  examEnvironmentDockerImageRuntimeUnavailable: "Docker 运行时暂不可用",
  examEnvironmentDockerImageBuildFailed: "镜像构建失败",
  examJudgeDataContractInvalid: "判题数据结构非法：{field}",
  examJudgeQuestionTypeNotSupported: "题目 #{question_id} 的类型 {question_type} 不支持判题",
  examJudgeSourceCodeNotFound: "未找到答卷题目 #{attempt_question_id} 的可判题代码",
  examJudgeRuntimeUnavailable: "{language} 判题运行环境暂不可用",
  examJudgeUnsupportedLanguage: "判题不支持语言 {language}",
  examJudgeSubmissionNotFound: "答卷题目 #{attempt_question_id} 的判题记录不存在",
  examJudgeServiceRequestFailed: "判题服务请求失败",
  examJudgeServiceUnavailable: "判题服务暂不可用",
  examJudgeServiceInvalidResponse: "判题服务返回了无效响应",
  examReviewObjectiveQuestionNotReviewable: "客观题 #{question_id} 不支持人工阅卷",
  examPlatformApplicationNotFound: "应用 {app_key} 不存在",
  examEnvironmentInstanceNotFound: "环境实例 #{instance_id} 不存在",
  examScoringScoresUnavailable: "答卷 #{attempt_id} 的成绩暂不可查看",
} as const;
